import api from '@api/Api';

export default {

    getMembers(id, params) {
        return api().get(`/campaigns/${id}/members`, { params: params });
    },

    getMembersStats(id, params) {
        return api().get(`/campaigns/${id}/members/stats`, { params: params });
    },

    getMember(id) {
        return api().get(`/campaigns/members/${id}`);
    },

    getJourneys(id, params) {
        return api().get(`/campaigns/members/${id}/journeys`, { params: params });
    },

    getEvents(id, params) {
        return api().get(`/campaigns/members/${id}/events`, { params: params });
    },

}
